<li class="list-item btn {{stateClass}}">
  <h3>{{item.reference}}</h3>
  <p>{{item.type}}</p>
  <div class="licence-period">
    {{__format "date" item.beginDate false ""}}
    -
    {{__format "date" item.endDate false ""}}
  </div>
</li>
